<template>
  <span>
    <span style="margin-right: 0px!important;">{{ show ? truePhoneNumber :maskPhoneNumber }}</span>
    <svg-icon class="show-icon" :icon-class="show ? 'eye-open' : 'eye'" @click="showPhone" />
  </span>
</template>

<script>
export default {
  name: 'MobileHidden',
  props: {
    encrypt: {
      type: String,
      default: ''
    },
    params: {
      type: Object,
      default: () => ({})
    }

  },
  data() {
    return {
      maskPhoneNumber: '',
      show: false,
      truePhoneNumber: ''
    }
  },
  watch: {
    encrypt(newVal) {
      if (newVal) {
        this.maskPhoneNumber = this.maskPhone(newVal)
      } else {
        this.maskPhoneNumber = ''
      }
    }
  },
  beforeMount() {
    if (this.encrypt) {
      this.maskPhoneNumber = this.maskPhone(this.encrypt)
    }
  },
  methods: {
    maskPhone(phone) {
      const reg = /^\d{11}$/
      if (!reg.test(phone)) return phone
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
    },
    showPhone() {
      if (!this.show) {
        this.$http.getMobile({ ...this.params }).then(res => {
          if (res.code === 200) {
            this.truePhoneNumber = res.data.mobile
            this.show = !this.show
          }
        })
      } else {
        this.show = !this.show
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .show-icon {
    margin-left: 10px;
  }
</style>
